import React from 'react';

const LoadingAnimation = props => (
  <div>Loading</div>
);

const Loader = props => (
  <div>
    {props.loading
      ? <LoadingAnimation />
      : props.children}
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.jsx